import {Component, OnInit, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {Document} from '../../../../domain/document';

export interface DialogData {
    name: string;
    pdf: Blob;
    pdfLink: string;
    document: Document;
}

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent {
    constructor(
        public dialogRef: MatDialogRef<PdfViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
    }

    onNoClick(): void {
        this.dialogRef.close();
        console.log(this.data.pdfLink);
    }

    descargar(): void {
        console.log(this.data.pdfLink);
        const downloadLink = document.createElement('a');
        downloadLink.href = this.data.pdfLink;
        downloadLink.download = this.data.name;
        downloadLink.click();
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/explorer/pdf-viewer/pdf-viewer.component.ts